import ViewBase from "../../../../view-base.view";

export default function CountsWidgetView() {
    ViewBase.call(this);
    let onClick=(type)=>{}
    return {
        oninit: function (vnode) {
          if(vnode.attrs.onClick){
            onClick=vnode.attrs.onClick;
          }

        },
       
        view: (vnode) => {
            let type=vnode.attrs.data.filter;
            return [

                  vnode.attrs.type=="tasks" &&    m('.schedule-visit-rate.d-flex.flex-nowrap',
                        m('.vr-group-data.bg-white',
                        m('div', 
                        {
                          class:type !="Task^^" ? " vr-data vr-data-primary vr-data-primary-bg-primary":"vr-data vr-data-primary vr-data-primary-bg-primary-selected",
                          onclick:()=>{onClick("Task^^")}},
                         // m('div',{class:vnode.attrs.data.planStatus !="PlannedVisit" ? "vr-label":""}, this.getText("LT00000176", "Planned")),
                           m('.font-size-0-75', this.getText("LT00000046", "Total")),
                          m('.vr-value', vnode.attrs.data.taskTotal),
                        ),
                        m('div', 
                        {
                          class:type !="Task^002^Y" ? "vr-data vr-data-secondary vr-data-secondary-bg-orange":"vr-data vr-data-secondary vr-data-secondary-bg-orange-selected",
                          onclick:()=>{onClick("Task^002^Y")}},
                          //m('div',{class:vnode.attrs.data.planStatus !="InProgressVisit" ? "vr-label":""}, this.getText("LT00000178", "In-Progress")),
                          m('.font-size-0-75', this.getText("LT00000115", "Mandatory")),
                          m('.vr-value',vnode.attrs.data.complete_mandatoty),
                        ),
                        m('div', 
                        {
                          class:type !="Task^002^N" ? "vr-data vr-data-secondary vr-data-secondary-bg-red":"vr-data vr-data-secondary vr-data-secondary-bg-red-selected",
                          onclick:()=>{onClick("Task^002^N")}},
                         // m('div',{class:vnode.attrs.data.planStatus !="NotVisited" ? "vr-label":""}, this.getText("LT00000179", "Not Visited")),
                          m('.font-size-0-75', this.getText("LT00000131", "Optional")),
                          m('.vr-value', vnode.attrs.data.complete_optional),
                        ),
                        m('div', 
                        {
                          class:type !="Task^001^Y" ? "vr-data vr-data-secondary vr-data-secondary-bg-orange":"vr-data vr-data-secondary vr-data-secondary-bg-orange-selected",
                          onclick:()=>{onClick("Task^001^Y")}},
                          //m('div',{class:vnode.attrs.data.planStatus !="InProgressVisit" ? "vr-label":""}, this.getText("LT00000178", "In-Progress")),
                          m('.font-size-0-75', this.getText("LT00000115", "Mandatory")),
                          m('.vr-value',vnode.attrs.data.nonComplete_mandatory),
                        ),
                        m('div', 
                        {
                          class:type !="Task^001^N" ? "vr-data vr-data-secondary vr-data-secondary-bg-red":"vr-data vr-data-secondary vr-data-secondary-bg-red-selected",
                          onclick:()=>{onClick("Task^001^N")}},
                         // m('div',{class:vnode.attrs.data.planStatus !="NotVisited" ? "vr-label":""}, this.getText("LT00000179", "Not Visited")),
                          m('.font-size-0-75', this.getText("LT00000131", "Optional")),
                          m('.vr-value', vnode.attrs.data.nonComplete_optional),
                        ),
                      )
                      ),
                      vnode.attrs.type=="site" &&    m('.schedule-visit-rate.d-flex.flex-nowrap',
                      m('.vr-group-data.bg-white',
                        m('div', 
                        {
                          class:type !="Site^^N" ? " vr-data vr-data-primary vr-data-primary-bg-primary":"vr-data vr-data-primary vr-data-primary-bg-primary-selected",
                          onclick:()=>{onClick("Site^^N")}},
                         // m('div',{class:vnode.attrs.data.planStatus !="PlannedVisit" ? "vr-label":""}, this.getText("LT00000176", "Planned")),
                           m('.font-size-0-75', this.getText("LT00000046", "Total")),
                          m('.vr-value', vnode.attrs.data.site_total),
                        ),
                        m('div', 
                        {
                          class:type !="Site^002^" ? "vr-data vr-data-secondary vr-data-secondary-bg-orange":"vr-data vr-data-secondary vr-data-secondary-bg-orange-selected",
                          onclick:()=>{onClick("Site^002^")}},
                          //m('div',{class:vnode.attrs.data.planStatus !="InProgressVisit" ? "vr-label":""}, this.getText("LT00000178", "In-Progress")),
                          m('.font-size-0-75', this.getText("LT00000177", "Completed")),
                          m('.vr-value',vnode.attrs.data.site_complete),
                        ),
                        m('div', 
                        {
                          class:type !="Site^001^" ? "vr-data vr-data-secondary vr-data-secondary-bg-red":"vr-data vr-data-secondary vr-data-secondary-bg-red-selected",
                          onclick:()=>{onClick("Site^001^")}},
                         // m('div',{class:vnode.attrs.data.planStatus !="NotVisited" ? "vr-label":""}, this.getText("LT00000179", "Not Visited")),
                          m('.font-size-0-75', this.getText("LT00000130", "Not Complete")),
                          m('.vr-value', vnode.attrs.data.site_nonComplete),
                        ),
                      ),
                    ),
                      this.getBaseViews()
            ]
        }
    }
}
